import { IOption } from "./IOption";

export interface IStatus {
  id: number;
  name: string;
}

export const convertIStatusToIOption = ({ id, name }: IStatus): IOption => ({ label: name, value: id })